export const useImageFocusDialogStore = defineStore('imageFocusDialog', () => {
  const imageFocusSrc = ref('');
  const imageFocus = ref<MediaAsset>();
  const imageFocusDialogOpen = ref(false);

  watch(imageFocusDialogOpen, imageFocusDialogIsOpen => {
    if (!imageFocusDialogIsOpen) {
      imageFocusSrc.value = '';
    }
  });

  /**
   * Opens the image focus dialog and sets the img src
   *
   * @param imageSrc
   */
  const openImageFocusDialog = async (image: MediaAsset) => {
    imageFocusSrc.value = await useMediaAssetUrl(image);
    imageFocus.value = image;
    imageFocusDialogOpen.value = true;
  };

  return {
    imageFocusSrc,
    imageFocus,
    imageFocusDialogOpen,
    openImageFocusDialog,
  };
});
